import './VLibras.less';

import { useEffect } from 'react';

const VLibras = () => {
  const widgetSrc = 'https://vlibras.gov.br/app';
  const scriptSrc = 'https://vlibras.gov.br/app/vlibras-plugin.js';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    script.onload = (load) => {
      new window.VLibras.Widget(
        widgetSrc,
        'https://vlibras.gov.br/config/default_logo.json',
      );
      // if (props.forceOnload) {
      //   window.onload();
      // }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div vw="" className="enabled" role="complementary">
      <div vw-access-button="" className="active"></div>
      <div vw-plugin-wrapper="">
        <div className="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  );
};

export default VLibras;
